export const industryFilter = (data: string): string => {
  try {
    return data.split(',')[0] + '展会'
  } catch (error) {
    return data + '展会'
  }
}

export const logoFilter = (value: string): string => {
  let parse: any = value
  try {
    parse = JSON.parse(value)[0].replace('http://', 'https://').replace(bucketHost, bucketCdnHost)
  } catch (error) {
    parse = value
    console.error(error)
  }
  return parse + '!logo'
}
